import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=1ef11606&scoped=true"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"
import style0 from "./NotFoundComponent.vue?vue&type=style&index=0&id=1ef11606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef11606",
  null
  
)

export default component.exports